import { History } from "lucide-react";
import { EmptyState } from "@/components/EmptyState";
import { useI18n } from "@/i18n/I18nProvider";

export default function MyHours() {
  const { t } = useI18n();
  return (
    <div>
      <h1 data-testid="my-hours-title" className="mb-6 font-display text-2xl font-extrabold text-[#000B45]">{t("portal.hoursTitle")}</h1>
      <EmptyState testId="my-hours-empty" icon={History} title={t("portal.hoursEmpty")} description={t("portal.clockSoon")} />
    </div>
  );
}
